import { render, staticRenderFns } from "./FormSignatureButtonNew.vue?vue&type=template&id=18706ba6"
import script from "./FormSignatureButtonNew.vue?vue&type=script&lang=js"
export * from "./FormSignatureButtonNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports